const shoppingReportReasonURL =
    process.env.REACT_APP_API_HOST +
  `/api/v3/contents/shoppings/paths/joints/reports/reasons`

export const readShoppingReportReasonWithPage = async (
  size: number,
  offset: number,
) => {
  const response = await fetch(
    shoppingReportReasonURL + `?size=${size}&offset=${offset}`,
    {
      method: 'GET',
      headers: {},
    },
  )

  if (!response.ok) {
    throw new Error('네트워크 오류: 쇼핑 문의 목록 조회에 실패했습니다.')
  }

  const responseData = await response.json()

  console.log(response)

  return responseData
}

export const readShoppingReportReasonCount = async () => {
  const response = await fetch(shoppingReportReasonURL + `/count`, {
    method: 'GET',
    headers: {},
  })

  if (!response.ok) {
    throw new Error('네트워크 오류: 쇼핑 문의 목록 계수 조회에 실패했습니다.')
  }

  const responseData = await response.json()

  console.log(response)

  return responseData
}
